import { apiRequest, apiExport } from '../index';
import { CONFIG_URL } from '../urls';

export const get = () => {
  return apiRequest('GET', `${CONFIG_URL}/INTEGRATION`, null);
};

export const update = (data: any) => {
  return apiRequest('POST', `${CONFIG_URL}/INTEGRATION`, data);
};

export default {
  get,
  update,
};
